import { useQuery } from 'react-query';
import { getOrderDetails } from '../apis';
import { OrderDetailResponse } from '../types/order';
import { useSession } from 'session';

export const useOrder = (orderId: string | undefined) => {
  const { can } = useSession();

  // Get the auth token
  const getAuthToken = () => {
    const auth = localStorage.getItem('authToken');
    if (!auth) return null;
    return JSON.parse(auth);
  };

  // Query for fetching order details
  const {
    data: orderDetails,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<OrderDetailResponse>({
    queryKey: ['orderDetails', orderId],
    // What would stop the order moving on is the forex desk's to see; others are not asked for it.
    queryFn: () => getOrderDetails(orderId as string, { readChecks: can('forex.desk') }),
    enabled: !!orderId && !!getAuthToken(),
    // A missing order is an answer, not a hiccup: retrying a 404 only keeps
    // the operator on a spinner for several seconds before the page says so.
    retry: (failures, err) =>
      (err as { response?: { status?: number } })?.response?.status !== 404 &&
      failures < 1,
  });

  // Utility function to download files
  const downloadFile = async (pdf_url: string, name: string) => {
    try {
      const response = await fetch(pdf_url);
      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = name;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      return true;
    } catch (error) {
      return false;
    }
  };

  return {
    orderDetails,
    isLoading,
    isError,
    error,
    refetch,
    downloadFile,
  };
};